import { Text } from '@cko/primitives';
import styled from 'styled-components';
/**
 * @deprecated -  This component is a styled Text with custom styling applied. Replace with Toolkit Text component and your required styles
 */
export const InlineText = styled(Text).attrs({
    as: 'div',
}) `
  &,
  > p,
  > span {
    font-weight: 500;
    color: var(--base-text-secondary);
  }
`;
